import React, { Fragment } from 'react';
import { Text as SlateText } from 'slate';
import escapeHTML from 'escape-html';
import { Image } from '../components/Image/Image';

export const serialize = children =>
  children?.map((node, i) => {
    if (node.type === 'numbered-list') {
      return <ol key={i}>{serialize(node.children)}</ol>;
    }

    if (SlateText.isText(node)) {
      let text = (
        <span dangerouslySetInnerHTML={{ __html: escapeHTML(node.text) }} />
      );

      if (node.bold) {
        text = <strong key={i}>{text}</strong>;
      }

      if (node.code) {
        text = <code key={i}>{text}</code>;
      }

      if (node.italic) {
        text = <em key={i}>{text}</em>;
      }

      if (node.underline) {
        text = (
          <span style={{ textDecoration: 'underline' }} key={i}>
            {text}
          </span>
        );
      }

      if (node.strikethrough) {
        text = (
          <span style={{ textDecoration: 'line-through' }} key={i}>
            {text}
          </span>
        );
      }

      return <Fragment key={i}>{text}</Fragment>;
    }

    if (!node) {
      return null;
    }

    switch (node.type) {
      case 'h1':
        return <h1 key={i}>{serialize(node.children)}</h1>;
      case 'h2':
        return <h2 key={i}>{serialize(node.children)}</h2>;
      case 'h3':
        return <h3 key={i}>{serialize(node.children)}</h3>;
      case 'h4':
        return <h4 key={i}>{serialize(node.children)}</h4>;
      case 'h5':
        return <h5 key={i}>{serialize(node.children)}</h5>;
      case 'h6':
        return <h6 key={i}>{serialize(node.children)}</h6>;
      case 'blockquote':
        return <blockquote key={i}>{serialize(node.children)}</blockquote>;
      case 'ul':
        return <ul key={i}>{serialize(node.children)}</ul>;
      case 'ol':
        return <ol key={i}>{serialize(node.children)}</ol>;
      case 'li':
        return <li key={i}>{serialize(node.children)}</li>;
      case 'list-item':
        return <li key={i}>{serialize(node.children)}</li>;
      case 'heading-one':
        return <h1 key={i}>{serialize(node.children)}</h1>;
      case 'heading-two':
        return <h2 key={i}>{serialize(node.children)}</h2>;
      case 'link':
        if (
          node.url.includes('youtube.com') ||
          node.url.includes('https://vk.com/video')
        ) {
          return (
            <div style={{ height: '420px' }}>
              <iframe
                width="100%"
                title="YouTube video player"
                src={node.url}
                allowFullScreen
                allow="accelerometer"
                referrerPolicy="strict-origin-when-cross-origin"
              />
            </div>
          );
        }
        return (
          <a
            href={escapeHTML(node.url)}
            key={i}
            rel="noopener noreferrer"
            style={{ color: 'blue' }}
          >
            {serialize(node.children)}
          </a>
        );

      case 'image':
        return (
          <Image
            src={escapeHTML(node.url)}
            srcSet={escapeHTML(node.url)}
            alt={escapeHTML(node.alt)}
            title={escapeHTML(node.title)}
            loading="lazy"
            itemProp="image"
          />
        );

      default:
        return <p key={i}>{serialize(node.children)}</p>;
    }
  });
